import { actionsInProgressAmount } from './preloader.cache';

export const preloader = {
  read() {
    return {
      actionsInProgressAmount: actionsInProgressAmount(),
    };
  },
};
